module.exports = __webpack_public_path__ + "static/media/big-neon-gif-5.53d46011.gif";